import React from 'react';
import { Backdrop, CircularProgress, Modal } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import { useFeatureFlag } from 'modules/common/hooks';
import { CircularProgressWithLabel } from './CircularProgressWithLabel';

type AppBackdropProps = {
  open: boolean;
  progress: number;
};

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    background: ({ isBetterUxEnabled }: { isBetterUxEnabled: boolean }) =>
      isBetterUxEnabled ? 'unset' : undefined
  }
}));

export const AppBackdrop: React.FC<AppBackdropProps> = ({
  open,
  progress
}: AppBackdropProps) => {
  const isBetterUxEnabled = useFeatureFlag('isSmartDiaryBetterUxEnabled');
  const classes = useStyles({ isBetterUxEnabled });

  return (
    <Modal open={open}>
      <Backdrop
        data-testid="back-drop"
        className={classes.backdrop}
        open={open}
      >
        {isBetterUxEnabled ? (
          <CircularProgressWithLabel progress={progress} />
        ) : (
          <CircularProgress data-testid="circular-progress" color="inherit" />
        )}
      </Backdrop>
    </Modal>
  );
};
